import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large);
  width: 100%;
`;

export const OrDivider = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-medium);
  width: 100%;
`;

export const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: linear-gradient(
    to right,
    transparent,
    var(--grey-300) 20%,
    var(--grey-300) 80%,
    transparent
  );
`;

export const OrText = styled.span`
  color: var(--grey-600);
  font-size: var(--font-size-text-sm);
  font-weight: var(--font-weight-regular);
  text-transform: lowercase;
`;